import { useQuery } from "@tanstack/react-query";
import { useLocation, useParams } from "react-router-dom";
import React, { useMemo, useState } from "react";
import { getAxiosImportServer } from "../../shared/Services/importService";
import { IMPORT_MARKET } from "../../utils/api/ApiConstant";
import { DataTable, Filter, SubHeading } from "../../shared/Components";
import { postAxios } from "../../shared/Services/commonService";
import showToast from "../../utils/toastUtil";
import DateUtils from "../../utils/dateUtils";
import { createImportColumn } from "../../utils/importColumn";

const ImportStep4 = () => {
  const location = useLocation();
  const rowData = location.state;
  const {
    id,
    source,
    sportName,
    tournamentName,
    matchName,
    sportId,
    tournamentId,
  } = useParams();
  const [selectedItems, setSelectedItems] = useState({});

  const { isLoading, data, refetch } = useQuery({
    queryKey: ["importMatchOddsData", source, id],
    queryFn: async () =>
      await getAxiosImportServer(`${IMPORT_MARKET}/${source}`, {
        event_id: id,
      }),
  });

  const handleSwitchToggle = (id) => {
    setSelectedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleImport = async () => {
    const selectedIds = Object.keys(selectedItems)
      .filter((id) => selectedItems[id])
      .map((id) => String(id));

    if (selectedIds.length === 0) {
      showToast.info("Please select at least one item to import");
      return;
    }

    try {
      const response = await postAxios(`${IMPORT_MARKET}/${source}`, {
        market_Ids: selectedIds,
        event_id: String(id),
      });

      setSelectedItems({});
      refetch();
    } catch (error) {
      console.error("Import failed", error);
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "Name",
        header: "Name",
      },
      {
        accessorKey: "actionOn",
        header: "Action Date",
        cell: ({ getValue }) => DateUtils.fromUTC(getValue()),
      },
      createImportColumn({
        data,
        selectedItems,
        setSelectedItems,
        handleSwitchToggle,
      }),
    ],
    [data, selectedItems],
  );

  return (
    <>
      <SubHeading
        eyebrow="Configuration"
        breadcrumbs={[
          {
            label: "Import",
          },
          {
            label: `Sport (${sportName})`,
            path: "/configuration/import",
          },
          {
            label: `Tournament (${tournamentName})`,
            path: `/config/import2/${source}/${sportId}/${sportName}`,
          },
          {
            label: `Match (${matchName})`,
            path: `/config/import3/${source}/${sportId}/${tournamentId}/${sportName}/${tournamentName}`,
          },
          {
            label: "Market",
          },
        ]}
        isAddBtnPage={false}
        isAddBtn={false}
        isBack={true}
        isImport={true}
        onClick={handleImport}
      />
      <Filter
        isEvent={true}
        isEventDisabled={true}
        buttonVisible={false}
        selectedSource={source}
      />
      <div className="card-body">
        <DataTable
          columns={columns}
          data={data?.data}
          isSearchable={false}
          isPagination={false}
          isPageSize={false}
          isLoading={isLoading}
        />
      </div>
    </>
  );
};

export default ImportStep4;
